interface ToolTipTextProps {
  text: string | React.ReactNode;
  width?: number;
}

const ToolTipText: React.FC<ToolTipTextProps> = ({ text, width }) => {
  return (
    <div
      className="font-medium text-xs leading-5 whitespace-normal"
      style={{ maxWidth: `${width}px` }}
    >
      {text}
    </div>
  );
};

export default ToolTipText;
